import { Action } from '@ngrx/store';


export enum AdmGrpModeloActionTypes {
  GET_ADM_GRPMODELO = '[ADM_GRPMODELO] GetGrpModelo',
  SET_ADM_GRPMODELO = '[ADM_GRPMODELO] SetGrpModelo',
  EDIT_ADM_GRPMODELO = '[ADM_GRPMODELO] EditGrpModelo',
  DELETE_ADM_GRPMODELO = '[ADM_GRPMODELO] DeleteGrpModelo',
  SUCESS_GRPMODELO = '[ADM_GRPMODELO] SuccessGrpModelo',
  FAIL_GRPMODELO = '[ADM_GRPMODELO] FailGrpModelo',
}

export class AdmGetGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.GET_ADM_GRPMODELO;
  constructor() {}
}

export class AdmSetGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.SET_ADM_GRPMODELO;
  constructor(public DatosModelo: any) {}
}
export class AdmEditGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.EDIT_ADM_GRPMODELO;
  constructor(public DatosModelo: any) {}
}

export class AdmDeleteGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.DELETE_ADM_GRPMODELO;
  constructor(public ObjDel: any) {}
}

export class AdmSuscessGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.SUCESS_GRPMODELO;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailGrpModelo implements Action {
  readonly type = AdmGrpModeloActionTypes.FAIL_GRPMODELO;
  constructor(public Respuesta: any) {}
}


export type AdmGrpModeloAcciones =
    | AdmGetGrpModelo
    | AdmSetGrpModelo
    | AdmEditGrpModelo
    | AdmDeleteGrpModelo
    | AdmSuscessGrpModelo
    | AdmFailGrpModelo;
